<template>
<div id="news-info" :style="isHeader?'marginTop:70px':'marginTop:0px'">
  <!-- <button @click="localCookie('https://m.zxzx119.com/news-info?newsID=13839')" >跳转</button> -->
  <mainHeader class="mainHeader" v-if="isHeader"></mainHeader>
  <div class="wrapper">
    <h2 style="margin-top: 15px;">{{newsTitle}}</h2>
    <div style='color: #bebebe;line-height: 25px;'>发布时间：{{newsCteateTime}}</div>
    <div style='color: #bebebe;line-height: 25px;' v-on:click="linkGoClick">来源：{{newsFrom}}</div>
    <hr style='height:1px;border:none;border-top:solid 1px #eeeeee;margin:15px 0;' />
    <p class="content" style="font-size: 16px; margin: 0px 0px 40px 0px;" v-html="htmlText"></p>
  </div>
  <!-- <div class="right" v-show="rightShow">
    <iframe src="test1.html" frameborder="0" width="100%" height="100%"></iframe>
  </div> -->
  <mainFooter class="mainFooter" v-if="isFooter"></mainFooter>
</div>

</template>

<script>
import mainHeader from '../view/header'
import mainFooter from '../view/footer'

import wxShare from '../wx/weixin.js'

export default{
  data () {
    return {
      newsTitle: '',
      newsCteateTime: '',
      newsSubTitle: '',
      newsFrom: '',
      newsFromLink: '',
      htmlText: '',
      rightShow: false,
      isHeader: true,
      isFooter : true,
    }
  },
  mounted: function () {
    var newsID = this.$route.query.newsID
    // 获取新闻详情数据
    this.loadNewsData(newsID)
    this.isHeader = this.$route.query.isHeader && this.$route.query.isHeader==0 ? false : true
    this.isFooter = this.$route.query.isFooter && this.$route.query.isFooter==0 ? false : true
  },
  watch: {
    $router () {
    }
  },
  methods: {
    localCookie(url) { 
      var iframe = document.querySelector("iframe");
      iframe.setAttribute("src", url)
      this.rightShow = true;
      window.frames[0].postMessage('jogging, reading and writing','https://m.zxzx119.com');
    },
    loadNewsData: function (newsID) {
      var _this = this
      this.utils.GET(this.accountUrl + '/jpressContent/detail?articleId=' + newsID,
        function (data) {
          _this.dataHandel(data)
        })
    },
    dataHandel: function (result) {
      this.htmlText = result.data.text
      this.newsTitle = result.data.title
      this.newsCteateTime = result.data.created
      this.newsSubTitle = result.data.meta_description
      this.newsFrom = '中消在线'
      this.newsFromLink = ''
      let froms = result.data.tails.metaData

      for (var i = 0; i < froms.length; i++) {
        var dict = froms[i]
        if (dict.meta_key === '_from') {
          if (dict.meta_value != null) {
            this.newsFrom = dict.meta_value
          }
        }
        if (dict.meta_key === '_link') {
          this.newsFromLink = dict.meta_value
        }
      }
      console.log(this.newsFrom)
      console.log(this.newsFromLink)

      // 图片处理
      setTimeout(() => {
        var maxWidth = document.body.clientWidth - 30
        if (maxWidth) {
          var myimg, oldwidth, oldheight
          var imgs = document.querySelectorAll('img')
          for (var i = 0; i < imgs.length; i++) {
            myimg = document.images[i]
            oldwidth = myimg.width
            oldheight = myimg.height
            myimg.width = maxWidth
            myimg.height = maxWidth * oldheight / oldwidth
          }
        }

        // tabbar 调整高度
        if (this.utils.isIphoneX()) {
          document.getElementById('news-ads').style.height = '70px'
        }
      }, 50)
      // http://www.zxzx119.com/static/spa/img/no_pic.20c23a8.png

      // 微信 分享
      var imgUrl = 'http://www.zxzx119.com/static/spa/img/no_pic.20c23a8.png'
      if (result.data.thumbnail != null && result.data.thumbnail.length > 0) {
        imgUrl = 'http://cdn.zxzx119.com' + result.data.thumbnail
      }
      wxShare.wxRegister(this.newsTitle, this.newsSubTitle, imgUrl)

      // 统计
      var newsID = this.$route.query.newsID
      this.utils.listenEvent(1, newsID, window.location.href, this.newsTitle)
    },
    linkGoClick: function (e) {
      if (this.newsFromLink != null && this.newsFromLink.length > 0) {
        window.location.href = this.newsFromLink
      }
    }
  },
  components: { // 注册组件
    mainHeader,
    mainFooter
  }
}
</script>

<style scoped="scoped">
.right{
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  top: 0;
}
body {
  padding-top: constant(safe-area-inset-top);
  padding-left: constant(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);
  padding-bottom: constant(safe-area-inset-bottom);
}
#news-info {
  margin: 70px 0px 0px 0px;
  height: 100%;
}
.wrapper {
  margin: 0px 15px;
}
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.mainFooter {
  /*position: fixed;*/
  width: 100%;
  bottom: 0px;
  z-index: 500;
}
img {
  width: 100%;
  height: auto;
}

</style>



// WEBPACK FOOTER //
// src/view/news-info.vue